import { makeObservable, observable } from "mobx"
import { PostElementBackground } from "@serializers/article"

import { BaseModel } from "./base.model"

export class HuaweiTipsModel extends BaseModel {
  // @ts-ignore
  constructor(params) {
    super(params)
    makeObservable(this)
  }

  @observable title: string = ""
  @observable blocks: Block[] = []

  getHuaweiTips = async () => {
    try {
      const { title, blocks } = await this.Providers.HuaweiTipsProvider.find(
        this.Models.GlobalModel.lang,
      )

      this.applyData({
        title,
        blocks,
      })
    } catch {}
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.applyData({ title: data?.title })
    // @ts-ignore
    this.applyData({ blocks: data?.blocks })
  }

  serialize = () => {
    return {
      title: this.title,
      blocks: this.blocks,
    }
  }
}

export interface Block {
  background: PostElementBackground
  Content: string
}
